import React from 'react';
import {IoMdClose} from 'react-icons/io';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import {Collapse, Drawer, Grid, List, ListItem, ListItemText} from '@mui/material';
import RegisterSubMenu from '../components/RegisterSubMenu';
import {useLocation} from 'react-router';
import {NavMenuItemType} from "../views/nav-menu/NavMenuSubmenuListItem";
import {Badge} from "../components/routing/Badge";
import {MobileMenuLink} from "../components/routing/MobileMenuLink";
import {styled} from "@mui/material/styles";

interface MobileMenuProps {
  closeNavMenu: () => void;
  handleClick: (label: string) => void;
  leftNavOptions: NavMenuItemType[];
  rightNavOptions: NavMenuItemType[];
  expanded: string | null;
  showMenu: boolean;
  buyerSpaceUsageRedesign: boolean;
}

const MobileMenuNested = styled(List<'nav'>)(({theme}) => ({
    paddingLeft: theme.spacing(4),
}));

const MobileMenu: React.FC<MobileMenuProps> = ({
                                                 closeNavMenu,
                                                 handleClick,
                                                 leftNavOptions,
                                                 rightNavOptions,
                                                 expanded,
                                                 showMenu,
                                                 buyerSpaceUsageRedesign,
                                               }) => {
  const location = useLocation();
  const showRegisterSubMenu = (menuItem: NavMenuItemType): boolean => menuItem?.path === 'register';
  const leftMenuItems = leftNavOptions?.filter((menu) => menu);

  /**
   * Resolves the display label for a menu item, applying any feature-flag renaming.
   */
  const getLabel = (menuItem: NavMenuItemType): string => {
    if (buyerSpaceUsageRedesign && menuItem.label === 'Booked Space Calendar') {
      return 'Space Usage';
    }
    return menuItem.label;
  };

  return (
    <>
      <Drawer className={`ss-nav-drawer`} anchor="right" open={showMenu} onClose={closeNavMenu}>
        <Grid className='ss-close-btn'>
          <IoMdClose size={20} onClick={closeNavMenu}/>
        </Grid>
        <List component="nav" className='ss-nav-drawer-item'>
          {leftMenuItems?.map((menuItem: NavMenuItemType, index: number) => (
            menuItem?.submenus ? (
              <React.Fragment key={index}>
                <ListItem
                  className={`ss-drawer-button ${location?.pathname === `/${menuItem?.path}` ? `ss-drawer-menu-item-highlighted ` : `ss-drawer-menu-item-unhighlighted`}`}
                  button onClick={() => handleClick(menuItem.label)}>
                  <ListItemText primary={menuItem.label}/>
                  {expanded === menuItem?.label ? <ExpandLess/> : <ExpandMore/>}

                  <Badge
                    type="mobile"
                    mobileClassName={'ss-mobile-badge'}
                    menuItem={menuItem}
                  />
                </ListItem>
                <Collapse in={expanded === menuItem?.label} timeout="auto" unmountOnExit>
                  <MobileMenuNested component="nav">
                    {menuItem.submenus?.map((mItem, idx: number) => (
                      <MobileMenuLink
                        key={idx}
                        menuItem={mItem}
                        onNavigate={closeNavMenu}
                        badgeClassName={'ss-mobile-badge'}
                        labelOverride={getLabel(mItem)}
                      />
                    ))}
                  </MobileMenuNested>
                </Collapse>
              </React.Fragment>
            ) : (
              <MobileMenuLink
                key={index}
                menuItem={menuItem}
                onNavigate={closeNavMenu}
                badgeClassName={'ss-mobile-badge'}
              />
            )
          ))}
          {rightNavOptions?.map((menuItem: NavMenuItemType, index: number) => (
            menuItem?.submenus ? (
              <React.Fragment key={index}>
                <ListItem
                  className={`ss-drawer-button ${location?.pathname === `/${menuItem?.path}` ? `ss-drawer-menu-item-highlighted ` : `ss-drawer-menu-item-unhighlighted`}`}
                  button onClick={() => handleClick(menuItem.label)}>
                  <ListItemText primary={menuItem.label}/>
                  {expanded === menuItem?.label ? <ExpandLess/> : <ExpandMore/>}

                  <Badge
                    type="mobile"
                    mobileClassName={'ss-mobile-badge'}
                    menuItem={menuItem}
                  />
                </ListItem>
                <Collapse in={expanded === menuItem?.label} timeout="auto" unmountOnExit>
                  <MobileMenuNested component="nav"
                        className={` ${showRegisterSubMenu(menuItem) ? 'ss-register-drawer-item' : ""}`}>
                    {showRegisterSubMenu(menuItem) ? (
                      <RegisterSubMenu show={true}/>
                    ) : (
                      menuItem.submenus?.map((mItem, idx: number) => (
                        <MobileMenuLink
                          key={idx}
                          menuItem={mItem}
                          onNavigate={closeNavMenu}
                          badgeClassName={'ss-mobile-badge'}
                          labelOverride={getLabel(mItem)}
                        />
                      ))
                    )}
                  </MobileMenuNested>
                </Collapse>
              </React.Fragment>
            ) : (
              <MobileMenuLink
                key={index}
                menuItem={menuItem}
                onNavigate={closeNavMenu}
                badgeClassName={'ss-mobile-badge'}
                className={menuItem?.path === "login" ? "ss-login-btn" : undefined}
              />
            )
          ))}
        </List>
      </Drawer>
    </>
  );
};

export default MobileMenu;
